export const DASHBOARDLEAVELIST_SEARCH = 'DASHBOARDLEAVELIST_SEARCH';
export const DASHBOARDLEAVELIST_PAGE = 'DASHBOARDLEAVELIST_PAGE';